export default __webpack_public_path__ + "static/media/1983.d4948f2f.png";